<template>
    <v-app>
        <bank-account-setup :dialog="dialog" :data="data" @update:dialog="dialog = $event" />
        
        <v-container fluid>
            <v-row>
                <v-col cols="12">
                    <v-expansion-panels v-model="panel" >
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Bank Account Records</v-expansion-panel-title>
                            <v-expansion-panel-text> 
                                    <v-row class="py-2">

                                        <v-col md="4" cols="12">
                                            <v-text-field
                                                v-model="search"
                                                append-inner-icon="mdi-magnify"
                                                label="Search"
                                                single-line
                                                hide-details
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                class="pl-2"
                                                clearable
                                            ></v-text-field>
                                        </v-col>

                                        <v-col md="5" cols="12">                                           
                                            <div class="d-flex align-center flex-column">
                                                <v-btn-group variant="outlined" density="compact" size="x-small"divided>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="success" @click="exportToCSV">CSV</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="primary" @click="exportToExcel">EXCEL</v-btn>
                                                    <v-btn  prepend-icon="mdi mdi-download"  variant="flat" color="red" @click="exportToPDF">PDF</v-btn>
                                                </v-btn-group>
                                            </div>
                                        </v-col>

                                        <v-col md="3" cols="12">
                                            <div class="text-right pr-2">
                                                <v-btn
                                                    v-if="$insertAccess($route.path)"
                                                    @click="openChequeBook"
                                                   class="bg-primary"
                                                    variant="tonal"
                                                    prepend-icon="mdi mdi-plus"
                                                    rounded="xl"
                                                >
                                                    Add Bank Account
                                                </v-btn>
                                            </div>
                                        </v-col>
                                            
                                    </v-row>                   
                                    <v-data-table
                                        :headers="headers"
                                        :items="getSchema"
                                        :loading="loading"
                                        v-model:items-per-page="itemsPerPage"
                                        :search="search"
                                        :hover="true"                    
                                        density="compact">

                                        <template v-slot:item.index="{ index }">
                                            {{ ++index }}
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status == 1" color="success" size="small" class="text-capitalize">Active</v-chip>
                                            <v-chip v-else color="red" size="small" class="text-capitalize">Inactive</v-chip>     
                                        </template>

                                        <template v-slot:item.actions="{ item }">
                                            <v-icon
                                                class="me-2 edit-button"
                                                color="primary"
                                                @click="editItem(item)"
                                                v-if="$updateAccess($route.fullPath)"
                                            >
                                                mdi mdi-pencil-outline
                                            </v-icon>

                                        </template>

                                    </v-data-table>             
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import bankAccountSetup from '@/components/module/accounts/chequeBook/bankAccountSetup.vue';

export default {
    components: {
        bankAccountSetup
    },
    data: () => ({
        itemsPerPage:10,
        panel: [0],
        loading:false,
        search: "",
        dialog: false,
        data:{},
        headers: [
            { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
            { title: "Account Title", key: "account_title",align: "left" ,sortable: false },
            { title: "Account No", key: "account_no",align: "left" ,sortable: false },
            { title: "Bank Name", key: "bank.name",align: "left" ,sortable: false },
            { title: "Branch", key: "branch.name",align: "left" ,sortable: false },
            { title: "Bank Account Head", key: "bank_account_head.name",align: "left" ,sortable: false },
            { title: "Routing Number", key: "routing_number",align: "left" ,sortable: false },
            { title: "Swift Code", key: "swift_code",align: "left" ,sortable: false },
            { title: "Status", align: "center", key: "status", sortable: true },
            { title: "Actions", align: "center", key: "actions", sortable: false }
        ],
    }),
    watch: {
    },
    created(){
        // if(this.$store.getters.getBankAccountList.length == 0){
            this.loading = true;
            this.$store.dispatch('getBankAccountList').then((response) => {
                this.loading = false;
            })
        // };
    },
    computed:{
        getSchema() {
            return this.$store.getters.getBankAccountList;
        },
    },
    methods: {
        openChequeBook() {
            this.data = {
                bank_id: null,
                bank_branch_id: null,
                account_no: "",
                routing_number: null,
                swift_code: null,
                bank_account_head_id: null,
                status: "1",
                remarks: "",
            };
            this.dialog = true;
        },
        editItem(item){
            this.data = { ...item };
            console.log(this.data)
            this.dialog = true;
        },
        formatExportData() {
            let sl = 1;
            return this.getSchema.map(item => (
                [sl++, item.account_title ?? '', item.account_no ?? '', item.bank?.name ?? '', item.branch?.name ?? '', item.routing_number ?? '', item.swift_code ?? '', item.status == 1 ? 'Active' : 'Inactive']
            ));
        },
        exportToPDF() {
            const columns = [ '#SL', 'Account Title', 'Account No', 'Bank Name', 'Branch', 'Routing Number', 'Swift Code', 'Status'];
            const rows = this.formatExportData();

            this.$exportTableToPDF(
                columns,
                rows,
                'Bank Account List',
                'bank_account_list_' + this.$fileDate()
            );
        },

        exportToExcel() {
            const data = [
                [ '#SL', 'Account Title', 'Account No', 'Bank Name', 'Branch', 'Routing Number', 'Swift Code', 'Status' ],
                ...this.formatExportData()
            ];

            this.$exportTableToExcel(
                data,
                'bank_account_list_' + this.$fileDate()
            );
        },

        exportToCSV() {
            const data = [
                [ '#SL', 'Account Title', 'Account No', 'Bank Name', 'Branch', 'Routing Number', 'Swift Code', 'Status' ],
                ...this.formatExportData()
            ];

            this.$exportTableToCSV(
                data,
                'bank_account_list_' + this.$fileDate()
            );
        },

    },
    mounted() {

    }  
}
</script>